import React from 'react';

import { applicationTitles } from '../../localization/en-us/applicationTitles';

import classes from './Title.module.css';

const home = props => {
    return (
        <div className={classes.TitleBox}>
            <img src="/assets/images/homeColorIcon.svg" alt="Home" />
            <p>{applicationTitles.home}</p>
        </div>
    );
};

export default home;
